import { render } from "./InvestmentBox.vue?vue&type=template&id=70867d6d&scoped=true"
import script from "./InvestmentBox.vue?vue&type=script&lang=js"
export * from "./InvestmentBox.vue?vue&type=script&lang=js"

import "./InvestmentBox.vue?vue&type=style&index=0&id=70867d6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70867d6d"]])

export default __exports__